<div class="rd-widget rd-widget-no-height-restriction widgetNoTopBorder">
  <table class="widget-small cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-small">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr class="dark-grey-line">
        <th scope="col" colspan="8" class="widgetNoTopBorderShowCell"><widget-label [widget]="this" [fieldName]="'labelSocioEconomicData'" [align]="'left'" [color]="'white'" [bold]="true"></widget-label></th>
        <th scope="col" colspan="3" class="widgetNoTopBorderShowCell"><widget-label [widget]="this" [fieldName]="'labelCountry'" [align]="'right'" [color]="'white'" [bold]="true"></widget-label></th>
        <th scope="col" colspan="3" class="widgetNoTopBorderShowCell"><widget-label [widget]="this" [fieldName]="'labelDistrict'" [align]="'right'" [color]="'white'" [bold]="true"></widget-label></th>
        <th scope="col" colspan="3" class="widgetNoTopBorderShowCell"><widget-label [widget]="this" [fieldName]="'labelRating'" [align]="'right'" [color]="'white'" [bold]="true"></widget-label></th>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'populationForecastCountry'" [align]="'left'"></widget-label></td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.populationForecastCountry || 0) | rdLocalizedNumber:2}}</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.populationForecastCountry" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.populationForecastDistrict || 0) | rdLocalizedNumber:2}}</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.populationForecastDistrict" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'">{{(widgetData.populationForecastRating || 0)| rdLocalizedNumber: 0}}</widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_socio_economic_data_rating']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.populationForecastRating"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'unemploymentRateCountry'" [align]="'left'"></widget-label></td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.unemploymentRateCountry || 0) | rdLocalizedNumber:2}}</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.unemploymentRateCountry" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.unemploymentRateDistrict || 0) | rdLocalizedNumber:2}}</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.unemploymentRateDistrict" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'">{{(widgetData.unemploymentRateRating || 0)| rdLocalizedNumber: 0}}</widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_socio_economic_data_rating']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.unemploymentRateRating"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'purchasingPowerIndexCountry'" [align]="'left'"></widget-label></td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{widgetData.purchasingPowerIndexCountry | rdLocalizedNumber:2}}</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.purchasingPowerIndexCountry" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'">{{(widgetData.purchasingPowerIndexDistrict || 0) | rdLocalizedNumber:2}}</widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.purchasingPowerIndexDistrict" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'">{{(widgetData.purchasingPowerIndexRating || 0)| rdLocalizedNumber: 0}}</widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_socio_economic_data_rating']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.purchasingPowerIndexRating"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="8">{{'socioEconomicData.labelPurchasingPowerPerCapita' | rdTranslate}} ({{currency}})</td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.purchasingPowerPerCapitaCountry || 0) | rdLocalizedNumber:2}}</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.purchasingPowerPerCapitaCountry" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.purchasingPowerPerCapitaDistrict || 0) | rdLocalizedNumber:2}}</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.purchasingPowerPerCapitaDistrict" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'">{{(widgetData.purchasingPowerPerCapitaRating || 0)| rdLocalizedNumber: 0}}</widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_socio_economic_data_rating']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.purchasingPowerPerCapitaRating"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'centralityIndexCountry'" [align]="'left'"></widget-label></td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.centralityIndexCountry || 0) | rdLocalizedNumber:2}}</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.centralityIndexCountry" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.centralityIndexDistrict || 0) | rdLocalizedNumber:2}}</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.centralityIndexDistrict" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'">{{(widgetData.centralityIndexRating || 0)| rdLocalizedNumber: 0}}</widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_socio_economic_data_rating']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.centralityIndexRating"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'gdpPerCapitaCountry'" [align]="'left'"></widget-label></td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.gdpPerCapitaCountry}}</label></widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <input type="text" class="widget-input-text gridster-item-content"     
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.gdpPerCapitaCountry= $event;"
          id="gdpPerCapitaCountry" [(ngModel)]="widgetData.gdpPerCapitaCountry" (ngModelChange)="setDirtyFlag(true)" />
        </td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.gdpPerCapitaDistrict}}</label></widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <input type="text" class="widget-input-text gridster-item-content"     
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.gdpPerCapitaDistrict= $event;"
          id="gdpPerCapitaDistrict" [(ngModel)]="widgetData.gdpPerCapitaDistrict" (ngModelChange)="setDirtyFlag(true)" />
        </td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'">{{(widgetData.gdpPerCapitaRating || 0)| rdLocalizedNumber: 0}}</widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_socio_economic_data_rating']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.gdpPerCapitaRating"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'inflationNext12MonthsCountry'" [align]="'left'"></widget-label></td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.inflationNext12MonthsCountry || 0) | rdLocalizedNumber:2}}%</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.inflationNext12MonthsCountry" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode"><widget-value [align]="'right'">{{(widgetData.inflationNext12MonthsDistrict || 0) | rdLocalizedNumber:2}}%</widget-value></td>
        <td colspan="3" *ngIf="editMode">
          <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="widgetData.inflationNext12MonthsDistrict" (valueChange)="setDirtyFlag(true)" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true"></pollux-report-designer-numeric-field>
        </td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'">{{(widgetData.inflationNext12MonthsRating || 0)| rdLocalizedNumber: 0}}</widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_socio_economic_data_rating']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.inflationNext12MonthsRating"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="8"><widget-label [widget]="this" [fieldName]="'populationCountry'" [align]="'left'"></widget-label></td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.populationCountry}}</label></widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <input type="text" class="widget-input-text gridster-item-content"     
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.populationCountry= $event;"
          id="populationCountry" [(ngModel)]="widgetData.populationCountry" (ngModelChange)="setDirtyFlag(true)" />
        </td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.populationDistrict}}</label></widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <input type="text" class="widget-input-text gridster-item-content"     
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.populationDistrict= $event;"
          id="populationDistrict" [(ngModel)]="widgetData.populationDistrict" (ngModelChange)="setDirtyFlag(true)" />
        </td>
        <td colspan="3" *ngIf="!editMode">
          <widget-value [align]="'right'">{{(widgetData.populationRating || 0)| rdLocalizedNumber: 0}}</widget-value>
        </td>
        <td colspan="3" *ngIf="editMode">
          <kendo-dropdownlist [data]="reflistDropDown['ref_l3_socio_economic_data_rating']" style="width:100%" class="widget-input-text"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              [(ngModel)]="widgetData.populationRating"
                              (ngModelChange)="setDirtyFlag(true)">
          </kendo-dropdownlist>
        </td>
      </tr>
      <tr class="white-line">
        <td colspan="17"><widget-label [widget]="this" [fieldName]="'labelRatingInfo'" [align]="'left'"></widget-label></td>
      </tr>
    </tbody>
  </table>
</div>
